import * as React from "react";
import {
  styledNav,
  styledTabPanes,
  styledRow,
} from "./FeaturesTabsCity.module.scss";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";

export const StyledNav: React.FC<{
  children: string | JSX.Element | JSX.Element[];
}> = (props) => {
  return <Nav className={styledNav}>{props.children}</Nav>;
};
export const StyledTabPanes: React.FC<{
  children: string | JSX.Element | JSX.Element[];
}> = (props) => {
  return <div className={styledTabPanes}>{props.children}</div>;
};
export const StyledRow: React.FC<{
  children: string | JSX.Element | JSX.Element[];
}> = (props) => {
  return <Row className={styledRow}>{props.children}</Row>;
};
